/**
 * Brewhouse welcome label from Firestore `users/{uid}` profile fields.
 *
 * @param {object | null | undefined} userDoc
 * @param {string | null | undefined} [fallbackEmail]
 * @returns {string}
 */
export function resolveUserWelcomeName(userDoc, fallbackEmail = '') {
  const displayName =
    typeof userDoc?.displayName === 'string' ? userDoc.displayName.trim() : '';
  if (displayName.length > 0) {
    return displayName;
  }

  const firstName =
    typeof userDoc?.firstName === 'string' ? userDoc.firstName.trim() : '';
  const lastName =
    typeof userDoc?.lastName === 'string' ? userDoc.lastName.trim() : '';
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  if (fullName.length > 0) {
    return fullName;
  }

  const email = typeof userDoc?.email === 'string' ? userDoc.email.trim() : '';
  if (email.length > 0) {
    return email;
  }

  const fallback =
    typeof fallbackEmail === 'string' ? fallbackEmail.trim() : '';
  return fallback.length > 0 ? fallback : '';
}
